<div class="row row-sm">
    <div class="col-lg-12">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12" *ngIf="submitButton">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/DistrictMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                {{'header.district-data.table.District'| translate}}  
                                </b></h3>
                                <p class="text-muted card-sub-title mb-0">
                                    {{'header.district-data.table.AddNewDistrictRecord' | translate}}
                                  </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="editButton">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/DistrictMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                {{'header.district-data.table.District'| translate}}
                                    </b></h3>

                                    <p class="text-muted card-sub-title mb-0">
                                        {{'header.district-data.table.UpdateDistrictRecord' |
                                        translate}}
                                    </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" *ngIf="deleteButton">
                    <div class="bc d-flex align-items-center pl-3">
                        <img alt="Logo" src="../../assets/img/DistrictMaster.png" class="mh-45px pb-2">
                        <div class="ml-2">
                            <h3 class="main-content-label mb-1"><b>
                                {{'header.district-data.table.District'| translate}}
                                   </b></h3>
                                    <p class="text-muted card-sub-title mb-0">
                                        {{'header.district-data.table.DeleteDistrictRecord' | translate}}
                                    </p>
                        </div>
                    </div>
                </div>
                <hr class="mt-3">
                <div class="row row-sm add-form">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="DistrictForm ">
                        <div class="col-lg-12 col-md-12">


                            <div class="row clearfix">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>{{'header.district-data.table.State'| translate}}
                                                     </mat-label>
                                                <mat-select formControlName="DsStateCode" placeholder="State"
                                                    class="colorblack" #select15>
                                                    <mat-select-filter *ngIf="select15.focused" [placeholder]="'Filter'"
                                                        [displayMember]="'StateName'" [array]="StateCodeList"
                                                        (filteredReturn)="filteredListState =$event"></mat-select-filter>
                                                    <mat-option *ngFor="let item of filteredListState" [value]="item.StateCode">
                                                        {{item.StateName}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error class="margin_tp"
                                            *ngIf="DistrictForm.controls['DsStateCode'].touched && DistrictForm.controls['DsStateCode'].errors?.required">
                                            {{'header.district-data.table.Mandatory'| translate}}
                                        </mat-error>
                                            </mat-form-field>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width ">
                                                <mat-label>
                                                    {{'header.district-data.table.DistrictCode' |
                                                    translate }}
                                                </mat-label>
                                                <input appUppercase onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                                    maxlength="5" [readonly]='isReadOnlyCode' placeholder="{{'header.district-data.table.DistrictCode' |
                                            translate}}" formControlName="DsCode" matInput required>
                                                <mat-error class="margin_tp"
                                                    *ngIf="DistrictForm.controls['DsCode'].touched && DistrictForm.controls['DsCode'].errors?.required">
                                                    {{'header.district-data.table.Mandatory'| translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="DistrictForm.controls['DsCode'].touched && DistrictForm.controls['DsCode'].errors?.pattern">
                                                     {{'header.district-data.table.Invalid'| translate}}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div class="">
                                            <mat-form-field appearance="outline" class="example-full-width ">
                                                <mat-label>
                                                    {{'header.district-data.table.DistrictName' |
                                                    translate }}
                                                </mat-label>
                                                <input appCamelcase onkeydown="return (event.keyCode!=13);" class="color" type="text"
                                                    maxlength="25" [readonly]="isreadonlydel" placeholder="{{'header.district-data.table.DistrictName' |
                                            translate }}" formControlName="DsName" matInput required>
                                                <mat-error class="margin_tp"
                                                    *ngIf="DistrictForm.controls['DsName'].touched && DistrictForm.controls['DsName'].errors?.required">
                                                    {{'header.district-data.table.Mandatory'| translate}}
                                                </mat-error>
                                                <mat-error class="margin_tp"
                                                    *ngIf="DistrictForm.controls['DsName'].touched && DistrictForm.controls['DsName'].errors?.pattern">
                                                    {{'header.district-data.table.Invalid'| translate}}
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2 prpl">

                                    <div class="col-sm-12" >

                                        <button id="Update" type="button" *ngIf="editButton && DisUpdate"
                                        class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                         (click)="update()">
                                        <span style="display: contents; align-items: center;">
                                             <img width="29%" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                                              {{'header.district-data.table.Update'| translate}}
                                        </span>
                                        </button>
                                        <button id="Save" type="button" *ngIf="submitButton && DisCreate"
                                        class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                         (click)="submit()">
                                        <span style="display: contents; align-items: center;">
                                             <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                             {{'header.district-data.table.Save'| translate}}
                                        </span>
                                        </button>
                                        <button id="Delete" type="button" *ngIf="deleteButton && DisDelete"
                                        class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                         (click)="openConformationModalBox()">
                                        <span style="display: contents; align-items: center;">
                                             <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                             {{'header.district-data.table.Delete'| translate}}
                                        </span>
                                        </button>
                                        <button id="Back" type="button" [mat-dialog-close]="true"
                                    class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                                    <span style="display: contents; align-items: center; margin-left:1rem;">
                                         <img width="23%" src="../../assets/img/turn-left.gif" style="margin-right: 5px;">
                                         {{'header.district-data.table.Back'| translate}}
                                    </span>
                                    </button>
                                   
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</div>